/**
 * We want muiPropForwarding to make sure that the argument of strings we find
 * do not get forwarded to the DOM
 *
 * Source: https://mui.com/system/styled/#heading-styled-component-options-styles-component
 *
 * @param  {...string} forwardedProps
 * @returns {(any) => bool}
 */
function muiPropForwarding(...forwardedProps) {
  return prop =>
    forwardedProps.reduce(
      (prev, forwardedProp) => prev && prop !== forwardedProp,
      true
    );
}

export default muiPropForwarding;
